import { render, staticRenderFns } from "./Tovoid.vue?vue&type=template&id=17c1d1e7&scoped=true"
import script from "./Tovoid.vue?vue&type=script&lang=js"
export * from "./Tovoid.vue?vue&type=script&lang=js"
import style0 from "./Tovoid.vue?vue&type=style&index=0&id=17c1d1e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c1d1e7",
  null
  
)

export default component.exports